import { Button, Space, Typography, Form, Divider, Input, Tooltip, Tabs, Segmented } from "antd";
import { FontSizeIcon, LetterSpacingIcon, PaddingHorizontalIcon, PaddingVerticalIcon } from "../../admin/Icons";
import { tt_border_radius, tt_border_size, tt_button_hover, tt_button_inital, tt_font_size, tt_letter_spacing, tt_margin_x, tt_margin_y, tt_padding_x, tt_padding_y, tt_shadow_blur, tt_shadow_spread, tt_shadow_x, tt_shadow_y } from "../../utils/Utils";
import { useState } from "react";
import ColourPicker from "./ColourPicker";
import BMInput from "../../admin/comps/BMInput";
import FontPicker from "./FontPicker";
import StylePicker from "./StylePicker";
export default function StyleButton(props) {

    const { default_button={}, callback = () => { }, button = {}, data = [], saveNew = () => { }, save = () => { }, is_new = false, is_edit = false, close = () => { } } = props;
    const { fonts = [], text_styles = [], colours = [] } = data;
    const [hover, setHover] = useState(false);

    // Button destructure
    const {
        id = 1,
        name = "",
        init_font = 0,
        init_style = 1,
        init_size = 14,
        init_letter_spacing = 0,
        init_colour = 0,
        init_background_colour = 0,
        init_padding_x = 10,
        init_padding_y = 5,
        init_margin_x = 0,
        init_margin_y = 0,
        init_border_colour = 0,
        init_border_size = 0,
        init_border_radius = 0,
        init_drop_shadow_colour = 0,
        init_drop_shadow_x = 0,
        init_drop_shadow_y = 0,
        init_drop_shadow_blur = 0,
        init_drop_shadow_spread = 0,
        hover_style = 1,
        hover_colour = 0,
        hover_background_colour = 0,
        hover_border_colour = 0,
        hover_border_size = 0,
        hover_border_radius = 0,
        hover_drop_shadow_colour = 0,
        hover_drop_shadow_x = 0,
        hover_drop_shadow_y = 0,
        hover_drop_shadow_blur = 0,
        hover_drop_shadow_spread = 0
    } = button;


    const StyleButtonForm = (props) => {

        const { callback = () => { }, id = 0, is_new = true, close = () => { }, save = () => { }, name = "" } = props;
        // Save name + activate button (if not activated)
        const saveName = (_f) => {

            if (is_new) {
                saveNew(_f.name, { ...default_button })
            } else {
                save(id, _f.name, ["name"], is_new);
            }

            close();
            callback(id);
        }


        return (
            <>
                <div key={id} style={{ "padding": "20px" }}>
                    <Typography.Title level={5}>{(is_new) ? "New" : "Edit"} Button</Typography.Title>
                    <Divider style={{ "margin": "15px 0px" }} dashed />
                    <Form onFinish={(_f) => saveName(_f)} layout="vertical">
                        <Form.Item name="id" initialValue={id} noStyle>
                            <Input hidden />
                        </Form.Item>
                        <Form.Item initialValue={(is_new) ? "" : name} rules={[{ required: true, message: "Button name is required" }]} label="Name" name="name">
                            <Input maxLength={20} placeholder="Button name..." />
                        </Form.Item>
                        <div className="float-flex">
                            <div>&nbsp;</div>
                            <Button htmlType="submit" type="primary">Save</Button>
                        </div>
                    </Form>
                </div>
            </>
        )
    }


    // NEW AND EDIT FORM
    if (is_new || is_edit) {
        return (
            <>
                <StyleButtonForm callback={callback} save={save} close={close} id={id} name={name} is_new={is_new} />
            </>
        )
    }

    const drawPreview = () => {

        return (
            <div className="label-border" style={{ "textAlign": "center" }}>
                <div style={{"height" : "100px", "overflow": "hidden"}}>
                

                <Button className={"bm-btn-" + id}>{name}</Button>

                
                {/* {JSON.stringify(_style, null, 2)} */}
                </div>
            </div>
        )

    }


    const tab_items = [
        {
            label: <small>INITIAL</small>, key: '0', children: (
                <div>
                    {/* INITIAL */}
                    <Divider orientationMargin={0} plain className="sublabel" orientation="left">INITIAL</Divider>
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">FONT</Divider>
                    <div className="float-flex">
                        <FontPicker value={init_font} onChange={(_v) => save(id, _v, ["init_font"])} fonts={fonts} />
                        <BMInput value={init_size} onChange={(_v) => save(id, _v, ["init_size"])} number min={14} max={100} prefix={<Tooltip title={tt_font_size}><FontSizeIcon style={{ "color": "#888", "fontSize": "12px" }} /></Tooltip>} />
                    </div>
                    <div className="shim" />
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">STYLE</Divider>
                    <div className="float-flex">
                        <StylePicker value={init_style} onChange={(_v) => save(id, _v, ["init_style"])} styles={text_styles} />
                        <BMInput value={init_letter_spacing} onChange={(_v) => save(id, _v, ["init_letter_spacing"])} number min={-100} max={100} prefix={
                            <Tooltip title={tt_letter_spacing}><LetterSpacingIcon style={{ "color": "#888", "fontSize": "12px" }} /></Tooltip>
                        } />
                    </div>
                    <div className="shim" />

                    {/* COLOR */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT COLOUR</Divider>
                    <ColourPicker allow_none value={init_colour} onChange={(_v) => save(id, _v, ["init_colour"])} colours={colours} />
                    <div className="shim" />

                    {/* BG COLOR */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                    <ColourPicker allow_none value={init_background_colour} onChange={(_v) => save(id, _v, ["init_background_colour"])} allow_gradient colours={colours} />
                    <div className="shim" />

                    {/* PADDING */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PADDING</Divider>
                    <div className="float-flex">
                        <Space>
                            <BMInput value={init_padding_x} onChange={(_v) => save(id, _v, ["init_padding_x"])} number min={0} max={100} prefix={<Tooltip title={tt_padding_x}><PaddingHorizontalIcon style={{"color" : "#888"}} /></Tooltip>} />
                            <BMInput value={init_padding_y} onChange={(_v) => save(id, _v, ["init_padding_y"])} number min={0} max={100} prefix={<Tooltip title={tt_padding_y}><PaddingVerticalIcon style={{"color" : "#888"}} /></Tooltip>} />
                        </Space>
                        <div></div>
                    </div>
                    <div className="shim" />

                    {/* MARGIN */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">MARGIN</Divider>
                    <div className="float-flex">
                        <Space>
                            <BMInput value={init_margin_x} onChange={(_v) => save(id, _v, ["init_margin_x"])} number min={-100} max={100} prefix={<Tooltip title={tt_margin_x}>X</Tooltip>} />
                            <BMInput value={init_margin_y} onChange={(_v) => save(id, _v, ["init_margin_y"])} number min={-100} max={100} prefix={<Tooltip title={tt_margin_y}>Y</Tooltip>} />
                        </Space>
                        <div></div>
                    </div>
                    <div className="shim" />

                    {/* BORDER */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BORDER</Divider>
                    <ColourPicker allow_none value={init_border_colour} onChange={(_v) => save(id, _v, ["init_border_colour"])} colours={colours} />
                    <div className="float-flex">
                        <div></div>
                        <Space>
                            <BMInput value={init_border_radius} onChange={(_v) => save(id, _v, ["init_border_radius"])} number min={0} max={100} prefix={<Tooltip title={tt_border_radius}>RADIUS</Tooltip>} />
                            <BMInput value={init_border_size} onChange={(_v) => save(id, _v, ["init_border_size"])} number min={0} max={100} prefix={<Tooltip title={tt_border_size}>SIZE</Tooltip>} />
                        </Space>
                    </div>

                    {/* SHADOW */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">SHADOW</Divider>
                    <ColourPicker allow_none value={init_drop_shadow_colour} onChange={(_v) => save(id, _v, ["init_drop_shadow_colour"])} colours={colours} />
                    <div className="float-flex">
                        <div></div>
                        <Space>
                            <BMInput width="40px" value={init_drop_shadow_x} onChange={(_v => save(id, _v, ["init_drop_shadow_x"]))} number min={-100} max={100} prefix={<Tooltip title={tt_shadow_x} >X</Tooltip>} />
                            <BMInput width="40px" value={init_drop_shadow_y} onChange={(_v => save(id, _v, ["init_drop_shadow_y"]))} number min={-100} max={100} prefix={<Tooltip title={tt_shadow_y} >Y</Tooltip>} />
                            <BMInput width="40px" value={init_drop_shadow_blur} onChange={(_v => save(id, _v, ["init_drop_shadow_blur"]))} number min={0} max={100} prefix={<Tooltip title={tt_shadow_blur} >BLUR</Tooltip>} />
                            <BMInput width="40px" value={init_drop_shadow_spread} onChange={(_v => save(id, _v, ["init_drop_shadow_spread"]))} number min={0} max={100} prefix={<Tooltip title={tt_shadow_spread} >SPREAD</Tooltip>} />
                        </Space>
                    </div>
                </div>
            )
        }, // remember to pass the key prop
        {
            label: <small>HOVER / FOCUS</small>, key: '1', children: (
                <div>
                    {/* HOVER / FOCUS */}
                    <Divider orientationMargin={0} plain className="sublabel" orientation="left">HOVER / FOCUS</Divider>

                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">STYLE</Divider>
                    <StylePicker value={hover_style} onChange={(_v) => save(id, _v, ["hover_style"])} styles={text_styles} />
                    <div className="shim" />

                    {/* COLOUR */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT COLOUR</Divider>
                    <ColourPicker allow_none value={hover_colour} onChange={(_v) => save(id, _v, ["hover_colour"])} colours={colours} />
                    <div className="shim" />

                    {/* BG COLOUR */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                    <ColourPicker allow_none value={hover_background_colour} allow_gradient onChange={(_v) => save(id, _v, ["hover_background_colour"])} colours={colours} />
                    <div className="shim" />

                    {/* BORDER */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BORDER</Divider>
                    <ColourPicker allow_none value={hover_border_colour} onChange={(_v) => save(id, _v, ["hover_border_colour"])} colours={colours} />
                    <div className="float-flex">
                        <div></div>
                        <Space>
                            <BMInput value={hover_border_radius} onChange={(_v) => save(id, _v, ["hover_border_radius"])} number min={0} max={100} prefix={<Tooltip title={tt_border_radius}>RADIUS</Tooltip>} />
                            <BMInput value={hover_border_size} onChange={(_v) => save(id, _v, ["hover_border_size"])} number min={0} max={100} prefix={<Tooltip title={tt_border_size}>SIZE</Tooltip>} />
                        </Space>

                    </div>
                    <div className="shim" />

                    {/* SHADOW */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">SHADOW</Divider>
                    <ColourPicker allow_none value={hover_drop_shadow_colour} onChange={(_v) => save(id, _v, ["hover_drop_shadow_colour"])} colours={colours} />
                    <div className="float-flex">
                        <div></div>
                        <Space>
                            <BMInput width="40px" value={hover_drop_shadow_x} onChange={(_v) => save(id, _v, ["hover_drop_shadow_x"])} number min={-100} max={100} prefix={<Tooltip title={tt_shadow_x} >X</Tooltip>} />
                            <BMInput width="40px" value={hover_drop_shadow_y} onChange={(_v) => save(id, _v, ["hover_drop_shadow_y"])} number min={-100} max={100} prefix={<Tooltip title={tt_shadow_y} >Y</Tooltip>} />
                            <BMInput width="40px" value={hover_drop_shadow_blur} onChange={(_v) => save(id, _v, ["hover_drop_shadow_blur"])} number min={0} max={100} prefix={<Tooltip title={tt_shadow_blur} >BLUR</Tooltip>} />
                            <BMInput width="40px" value={hover_drop_shadow_spread} onChange={(_v) => save(id, _v, ["hover_drop_shadow_spread"])} number min={0} max={100} prefix={<Tooltip title={tt_shadow_spread} >SPREAD</Tooltip>} />
                        </Space>
                    </div>
                    <div className="shim" />
                </div>
            )
        }, // remember to pass the key prop
    ];



    return (
        <>

            {drawPreview()}
            <div className="shim" /><div className="shim" />
            <Segmented value={hover} onChange={(e) => setHover(e)} style={{ "fontSize": "11px" }} block options={
                [
                    {
                        label: <Tooltip title={tt_button_inital}>Initial</Tooltip>,
                        value: false
                    }, {
                        label:  <Tooltip title={tt_button_hover}>Hover / Focus</Tooltip>,
                        value: true
                    }
                ]
            } />

            <Tabs activeKey={(hover) ? "1" : "0"} className="button_tabs" items={tab_items} size="small" />












        </>
    )

}